var React = require('react');

function Contact (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.42 5.978c-1.632 0-2.96-1.34-2.96-2.989C2.46 1.341 3.787 0 5.42 0c1.63 0 2.957 1.341 2.957 2.99 0 1.647-1.327 2.988-2.958 2.988m0 8.267C1.912 14.245 0 13.377 0 12.931c0-2.276 1.681-5.483 5.42-5.483 3.694 0 5.417 3.272 5.417 5.483 0 .446-1.913 1.314-5.419 1.314","fill":"currentColor","fillRule":"evenodd"}));
}

Contact.defaultProps = {"width":"11","height":"15","viewBox":"0 0 11 15"};

module.exports = Contact;

Contact.default = Contact;
